export default __webpack_public_path__ + "static/media/57.f72d36bd.png";